var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 512c0-282.778 229.222-512 512-512s512 229.222 512 512c0 282.778-229.222 512-512 512s-512-229.222-512-512zM716.8 512l-307.2-230.4v460.8l307.2-230.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.31ab2269c88752db5c4e3c4a5abc32ce.svg";
export { ForwardRef as ReactComponent };